import { render, staticRenderFns } from "./profilayarlari.vue?vue&type=template&id=41ac2134&"
import script from "./profilayarlari.vue?vue&type=script&lang=js&"
export * from "./profilayarlari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports